import React from 'react';
import PropTypes from 'prop-types';

import QuestionCircle from '@deliveroo/icon-set/react/QuestionCircle';
import Button from '@deliveroo/consumer-component-library/components/Button';
import OrderStatusDetails from '../OrderStatusDetails';
import { ListItemPlaceholder, SingleLinePlaceholder, TwoLinePlaceholder } from '../Placeholder';

import i18n from '../../utils/i18n';
import styles from './styles.scss';

export default function OrderDetailsSkeleton({ isPolling, openOrderHelpModal }) {
  return (
    <OrderStatusDetails>
      <div key="order-button" hideonmobile="true">
        <Button isBlock icon={QuestionCircle} type="primary" onClick={openOrderHelpModal}>
          {i18n.gettext('order_status_page.order_help')}
        </Button>
      </div>

      <div key="delivery-details">
        <TwoLinePlaceholder type="square" withFlashing={isPolling} />
        <div className={styles.showLarge}>
          <div className={styles.listDivider} />
          <SingleLinePlaceholder withFlashing={isPolling} />
        </div>
      </div>

      <div key="skeleton-list">
        <TwoLinePlaceholder type="circle" withFlashing={isPolling} />
        <div className={styles.listDivider} />
        <div className={styles.listItems}>
          <ListItemPlaceholder withFlashing={isPolling} />
          <ListItemPlaceholder withFlashing={isPolling} />
          <ListItemPlaceholder withFlashing={isPolling} />
        </div>
        <div className={styles.listDivider} />
        <SingleLinePlaceholder withFlashing={isPolling} />
      </div>
    </OrderStatusDetails>
  );
}

OrderDetailsSkeleton.propTypes = {
  isPolling: PropTypes.bool,
  /**
   * Action to open the OrderHelpModal
   */
  openOrderHelpModal: PropTypes.func,
};

OrderDetailsSkeleton.defaultProps = {
  isPolling: true,
  openOrderHelpModal: () => {},
};
